"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var index_1 = require("../index");
var theme = require("./theme.scss");
var headers2 = [{
        label: "Date",
        sortBy: "date",
        searchKey: "date",
    }, {
        label: "Name",
        sortBy: "name",
        searchKey: "name"
    }, {
        label: "Request",
        sortBy: "request",
        searchKey: "request",
    }];
var List = /** @class */ (function (_super) {
    tslib_1.__extends(List, _super);
    function List(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderHeaderAndFooter = function (scrollTop, scrollLeft, columnsWidth, setFreesColumn, freezeColumnIndex) {
            var _a = _this.props, sortDirection = _a.sortDirection, onSearch = _a.onSearch, sortBy = _a.sortBy, onSort = _a.onSort, searchQueries = _a.searchQueries, headers = _a.headers;
            return (React.createElement(ui_1.DataGridRow, { columnsWidth: columnsWidth }, headers && headers.map(function (header) {
                var props = {
                    key: header.label,
                    blue: true,
                    label: header.label,
                    sortable: !!header.sortBy,
                    sortBy: header.sortBy,
                    sortActive: sortBy === header.sortBy,
                    searchKey: header.searchKey,
                    searchable: !!header.searchKey,
                    searchQuery: searchQueries[header.searchKey || ""],
                    freezeColumnIndex: freezeColumnIndex,
                    columnsWidth: columnsWidth,
                    setFreesColumn: setFreesColumn,
                    sortDirection: sortDirection,
                    onSort: onSort,
                    onSearch: onSearch,
                };
                return (React.createElement(ui_1.DataGridHeaderColumn, tslib_1.__assign({}, props)));
            })));
        };
        _this.onColumnResize = function (columnsWidth) {
            _this.props.setColumnsWidth(columnsWidth);
        };
        _this.renderRow = function (index, viewportIndex, columnsWidth, freezeColumnIndex) {
            var _a = _this.props, items = _a.items, sortBy = _a.sortBy, onShowInfo = _a.onShowInfo, playerAction = _a.playerAction, onGenerateLink = _a.onGenerateLink, itemKeys = _a.itemKeys;
            var item = items[index];
            return (React.createElement(index_1.LogFormRow, { key: item._id, item: item, sortBy: sortBy, columnsWidth: columnsWidth, freezeColumnIndex: freezeColumnIndex, index: index, onShowInfo: onShowInfo, playerAction: playerAction, onGenerateLink: onGenerateLink, itemKeys: itemKeys }));
        };
        return _this;
    }
    List.prototype.render = function () {
        var _a = this.props, items = _a.items, headers = _a.headers, getColumnsWidth = _a.getColumnsWidth;
        var columnsWidth = getColumnsWidth();
        return (React.createElement(ui_1.DataGrid, { onColumnResize: this.onColumnResize, className: theme.list, extraData: items, headersCount: headers ? headers.length : 0, itemsCount: items.length, renderRow: this.renderRow, rowHeight: 60, columnsWidth: columnsWidth, renderHeader: this.renderHeaderAndFooter }));
    };
    return List;
}(React.Component));
exports.default = List;
